export default {
  menu: 'Warehouses',
  title: 'Warehouses',

  general: {
    labels: {
      name: 'Name',
      code: 'Code',
      delete: 'Delete',
      on_way: 'On way',
      main: 'Default'
    },

    notifications: {
      insert: {
        success: 'New warehouse information successfully registered',
        error: 'Add new warehouse failed'
      },
      edit: {
        success: 'Warehouse information successfully edited',
        error: 'Editing warehouse information failed'
      },
      delete: {
        success: 'Warehouse information successfully deleted',
        error: 'Deleting warehouse information failed'
      },
      restore: {
        success: 'Warehouse successfully returned',
        error: 'Warehouse restored failed'
      },
      parseError: {
        name: 'Warehouse with this name exist'
      }
    },

    confirmations: {
      delete: {
        title: 'Warehouse deletion confirmation',
        body: 'Are you sure you want to temporarily delete warehouse {name}?'
      },
      forceDelete: {
        title: 'Warehouse deletion confirmation',
        body: 'Are you sure you want to delete {name} permanently?'
      }
    },

    validators: {
      name: 'Warehouse name not entered correctly',
      nameCantEmpty: 'Warehouse name could not be empty',
      code: 'Warehouse code not entered correctly',
      codeCantEmpty: 'Warehouse code could not be empty'
    }
  },

  list: {
    title: 'Warehouses',

    table: {
      header: {
        rowNumber: 'Row',
        code: 'Code',
        name: 'Title',
        balance: 'Inventory'
      }
    }
  },

  insert: {
    title: 'Add Warehouse'
  },

  edit: {
    title: 'Edit Warehouse'
  },

  store: {
    title: 'Warehouse',

    importantData: {
      code: 'Warehouse ID'
    },

    actions: {
      storeTransactions: 'Transactions',
      storeTurnover: 'Turnover',
      storeInventory: 'Inventory',
      storeInventoryValuation: 'Inventory valuation',
      logs: 'Time lines'
    }
  },

  trash: {
    title: 'Warehouse',

    table: {
      header: {
        rowNumber: 'Row',
        code: 'Code',
        name: 'Title',
        delete: 'Delete',
        restore: 'Restore'
      }
    }
  },

  transactions: {
    title: 'Transaction',
    dynamicTitle: '{name} Transaction',

    table: {
      header: {
        row: 'Row',
        docNumber: 'Document number',
        name: 'Title',
        image: 'Photo',
        date: 'Date',
        barcode: 'Barcode',
        code: 'Code',
        category: 'Category',
        variant: 'Variable',
        quantity: 'Number',
        unitPrice: 'Unit amount',
        description: 'Documents',
        price: 'Amount',
        balance: 'Inventory',
        status: 'Status'
      }
    },

    statusMapper: {
      sent: 'Posted',
      onWay: 'On way',
      received: 'Receipted',
      waitingToSend: 'Waiting to send'
    }
  },

  logs: {
    title: 'Warehouse logs'
  }
}
